import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Table,
  InputNumber,
  Space,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import {
  materialTypeService,
  measurementTypeService,
  packingTypeService,
  stockClassificationService,
} from "_services";
import TabMenu from "./TabMenu";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

let lineIndex = 0;

function Summary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [stockType, setStockType] = useState({});
  const [packingTypes, setPackingTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);
  //const [qualityTypes, setQualityTypes] = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [materialLines, setMaterialLines] = useState([]);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);
    materialTypeService
      .getById(id)
      .then((x) => {
        let data = x.content;
        setIsLoading(false);
        setStockType(x.content);
        setMaterialLines(x.content.materials);
        if (x.content.stockClass.name === "FINISHED PRODUCT") {
          getRawMaterials(x.content.stockClass);
        }
        onFill(data);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
    packingTypeService.getSuggestion().then((x) => {
      setPackingTypes(x.content);
    });
    stockClassificationService.getSuggestion().then((x) => {
      setStockClasses(x.content);
    });
    getMeasurements();
  }, []);

  const getRawMaterials = (classification) => {
    setIsLoading(true);
    materialTypeService
      .search(`?stockClassId=${classification.id}`)
      .then((x) => {
        setIsLoading(false);
        setRawMaterials(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getMeasurements = () => {
    measurementTypeService
      .getSuggestion()
      .then((x) => {
        setMeasurementTypes(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const handleAddMaterialLine = () => {
    const defaultMeasurementType = measurementTypes.find(
      (item) => item.name === "KG"
    );

    const newLine =
      defaultMeasurementType === null
        ? {}
        : {
            measurementType: defaultMeasurementType.id,
          };
    newLine.key = lineIndex;
    const lines = [...materialLines, newLine];
    setMaterialLines(lines);
    lineIndex += 1;
  };

  const handleRemoveMaterialLine = (line) => {
    const lines = [...materialLines];
    if (lines.includes(line)) {
      lines.splice(lines.indexOf(line), 1);
      setMaterialLines(lines);
    }
  };

  const handleSaveMaterialLine = (e, key) => {
    e.persist();
    const target = getRowBykey(key) || {};
    if (
      !target.materialType ||
      !target.quantityPerUnit ||
      !target.conversionRatio ||
      !target.wastagePercentage ||
      !target.measurementType
    ) {
      message.error("Please complete the raw material line details.");
      e.target.focus();
      return;
    }
    handleAddMaterialLine();
  };

  const getRowBykey = (key, newData) => {
    return (materialLines || newData).filter((item) => item.key === key)[0];
  };

  const handleFieldChange = (value, fieldName, key) => {
    const lines = [...materialLines];
    const newMaterialLines = lines.map((line) => {
      const newLine = Object.assign({}, line);
      if (newLine.key === key) {
        if (fieldName === "materialType") {
          newLine[fieldName] = rawMaterials.find((item) => item.id === value);
          return newLine;
        } else {
          newLine[fieldName] = value;
          return newLine;
        }
      }
      return newLine;
    });
    setMaterialLines(newMaterialLines);
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "HS Code",
      dataIndex: "materialType",
      key: "materialType",
      //width: "20%",
      render: (text, record) => {
        if (text) {
          return `${text.code}`;
        }
      },
    });
    columns.push({
      title: "Company Code",
      dataIndex: "materialType",
      key: "materialType",
      //width: "20%",
      render: (text, record) => {
        if (text) {
          return `${text.secondaryCode}`;
        }
      },
    });
    columns.push({
      title: "Description",
      dataIndex: "materialType",
      key: "materialType",
      //width: "20%",
      render: (text, record) => {
        if (text) {
          return `${text.name}`;
        }
      },
    });
    columns.push({
      title: "Quantity Per Unit",
      dataIndex: "quantityPerUnit",
      key: "quantityPerUnit",
    });
    columns.push({
      title: "Conversion Ratio",
      dataIndex: "conversionRatio",
      key: "conversionRatio",
    });
    columns.push({
      title: "Wastage Percentage",
      dataIndex: "wastagePercentage",
      key: "wastagePercentage",
    });
    columns.push({
      title: "UOM",
      dataIndex: "uom",
      key: "uom",
      render: (text, record) => {
        if (text) {
          return text.name;
        }
      },
    });

    return columns;
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/material-types");
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      /* buttons.push(
        <Popconfirm
          key="update-confirm"
          title="Are you sure to update the changes?"
          onConfirm={handleFormSumbit}
        >
          <Button key="1" type="primary" htmlType="submit" loading={isLoading}>
            Save
          </Button>
        </Popconfirm>
      ); */
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-types">Material Type Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Material Type: {stockType.code}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <Spin tip="Loading..." spinning={isLoading}>
            <TabMenu menu="summary" id={id} />
            <Form
              form={form}
              name="form-create"
              layout="vertical"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="code"
                    label="HS Code"
                    rules={[{ required: true, message: "HS Code is required" }]}
                  >
                    <Input placeholder="HS Code" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="secondaryCode"
                    label="Customer Code"
                    rules={[
                      { required: true, message: "Customer Code is required" },
                    ]}
                  >
                    <Input placeholder="Customer Code" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["stockClass", "id"]}
                    label="Stock Classification"
                    rules={[
                      {
                        required: true,
                        message: "Stock classification is required",
                      },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear disabled>
                      {stockClasses.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: "Name is required" }]}
                  >
                    <Input placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["packingType", "id"]}
                    label="Packing Type"
                    rules={[
                      { required: true, message: "Packing type is required" },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {packingTypes.length > 0 &&
                        packingTypes.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  {/* <Form.Item name={["qualityType", "id"]} label="Quality Type" rules={[
                  {
                    required: true,
                    message: "Quality Type is required",
                  },
                ]}>
                  <Select
                    showSearch
                    allowClear
                    showArrow={false}
                    optionFilterProp="children"
                    placeholder="Quality Type"
                  >
                    {qualityTypes.map((t) => (
                      <Select.Option value={t.id} key={t.id}>
                        {t.name} ({t.code})
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item> */}
                </Col>
                <Col span={6}></Col>
              </Row>

              {stockType &&
                stockType.stockClass &&
                stockType.stockClass.name === "FINISHED PRODUCT" &&
                stockType.materials.length > 0 && (
                  <Table
                    bordered
                    pagination={false}
                    columns={getLineColumns()}
                    dataSource={stockType.materials}
                    size="small"
                  />
                )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
